import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="pt-[76px]">
      <SEO title="Page introuvable | Fiscoconseils" description="La page demandée n'existe pas ou a été déplacée." noindex />
      <section className="max-w-3xl mx-auto px-5 lg:px-8 py-32 text-center">
        <p className="font-heading text-7xl text-[#C4C8CC]">404</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-[#0A1128] mt-4">Cette page n'existe pas</h1>
        <p className="text-base text-[#4B5563] mt-4">Retrouvez nos guides fiscaux pour frontaliers ou demandez un devis personnalisé.</p>
        <div className="flex flex-wrap justify-center gap-3 mt-10">
          <Link to="/guides-fiscaux-frontaliers" data-testid="notfound-guides-link" className="inline-flex items-center gap-2 text-sm font-semibold text-white bg-[#0A1128] rounded-full px-6 py-3 hover:bg-[#1A2342] transition-colors duration-200">Guides fiscaux frontaliers <ArrowRight size={15} /></Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-[#0A1128] border border-[#C4C8CC] rounded-full px-6 py-3 hover:bg-[#F8F9FA] transition-colors duration-200">Accueil</Link>
        </div>
      </section>
    </main>
  );
}
